import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'cm-field-display-grid',
  standalone: true,
  templateUrl: './field-display-grid.component.html',
  styleUrl: './field-display-grid.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldDisplayGridComponent {
  public readonly fields = input.required<{ label: string; value: string }[]>();
  public readonly loading = input<boolean>(false);
}
